import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiPackage, FiCheck, FiShield, FiAlertCircle, FiTrendingUp } = FiIcons;
import { mockEmailPacks } from '../data/mockData';

const EmailPacks = () => {
  return (
    <div className="space-y-8 animate-in fade-in duration-700">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Email Packs & Allowance</h2>
          <p className="text-sm text-slate-500">Internal billing plans and quota policies for BPA clients.</p>
        </div>
        <button className="px-5 py-2.5 bg-slate-900 text-white text-sm font-bold rounded-xl shadow-md hover:bg-slate-800 transition-all">
          Create New Pack
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {mockEmailPacks.map(pack => (
          <div key={pack.id} className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col hover:border-blue-300 transition-all">
            <div className="p-6 border-b border-slate-100 bg-slate-50/50">
              <h3 className="text-lg font-bold text-slate-800">{pack.name}</h3>
              <div className="flex items-baseline gap-1 mt-2">
                <span className="text-2xl font-black text-slate-900">${pack.price}</span>
                <span className="text-xs text-slate-500 font-medium">/ {pack.cycle}</span>
              </div>
            </div>
            <div className="p-6 flex-1 space-y-4">
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-slate-600">
                   <SafeIcon icon={FiCheck} className="text-emerald-500" />
                   <span><b>{pack.monthlyAllowance.toLocaleString()}</b> emails / mo</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-600">
                   <SafeIcon icon={FiCheck} className="text-emerald-500" />
                   <span><b>{pack.annualAllowance.toLocaleString()}</b> emails / yr</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-600">
                   <SafeIcon icon={FiCheck} className="text-emerald-500" />
                   <span>Unlimited Apps & Keys</span>
                </div>
              </div>
              
              <div className="pt-4 border-t border-slate-50 space-y-3">
                 <div className="flex justify-between text-[10px] font-bold uppercase text-slate-400">
                    <span>Soft Warning</span>
                    <span className="text-amber-600">{pack.warning}%</span>
                 </div>
                 <div className="flex justify-between text-[10px] font-bold uppercase text-slate-400">
                    <span>Hard Block</span>
                    <span className="text-red-600">{pack.block}%</span>
                 </div>
                 <div className="flex justify-between text-[10px] font-bold uppercase text-slate-400">
                    <span>Overage</span>
                    <span className="text-slate-800">{pack.overage}</span>
                 </div>
              </div>
            </div>
            <div className="p-4 bg-slate-50">
              <button className="w-full py-2 bg-white border border-slate-200 text-slate-700 text-xs font-bold rounded-lg hover:bg-white hover:border-blue-400 transition-all">
                Edit Pack Details
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-slate-900 rounded-2xl p-8 text-white">
        <div className="flex flex-col lg:flex-row gap-8 items-center">
          <div className="flex-1 space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-500/10 text-blue-400 rounded-full text-xs font-bold uppercase tracking-wider">
               <SafeIcon icon={FiShield} /> Global Policy
            </div>
            <h3 className="text-2xl font-bold">Automatic Overage Enforcement</h3>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xl">
              By default, the gateway enforces a **Hard Block at 100%** of the monthly allowance. BPA Staff can manually override this for specific clients in the "Allow & Flag" mode, which permits sending while generating a billing alert for the next cycle.
            </p>
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-500"></div>
                <span className="text-xs text-slate-300">Soft Warning: 80%</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
                <span className="text-xs text-slate-300">Hard Block: 100%</span>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-72 bg-white/5 rounded-xl p-6 border border-white/10 space-y-4">
             <div className="flex justify-between items-center">
                <span className="text-xs text-slate-400">Avg. Utilization</span>
                <span className="text-emerald-400 font-bold">+12%</span>
             </div>
             <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 w-[65%]"></div>
             </div>
             <p className="text-[10px] text-slate-500 leading-tight">System-wide email volume is currently at 65% of total provider capacity.</p>
             <button className="w-full py-2 bg-blue-600 text-white text-xs font-bold rounded-lg hover:bg-blue-700 transition-colors">
                View Load Report
             </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPacks;